import { render, staticRenderFns } from "./SummaryCompany.vue?vue&type=template&id=64e298d6&scoped=true&"
import script from "./SummaryCompany.vue?vue&type=script&lang=js&"
export * from "./SummaryCompany.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCompany.vue?vue&type=style&index=0&id=64e298d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e298d6",
  null
  
)

export default component.exports